/**
 * Compute the same SHA-256-based doc ID hash as the backend uses for bookmark keys.
 * Must match `_doc_id_hash()` in `backend/functions/user_prefs_api/app.py`.
 */
export async function docIdHash(docId: string): Promise<string> {
  const data = new TextEncoder().encode(docId);
  const buffer = await crypto.subtle.digest('SHA-256', data);
  const hex = Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hex.slice(0, 16);
}
